import { createFileRoute } from '@tanstack/react-router';

import { ParentsOnboardingBatchesPage } from '~pages/parents/csv-batch-processing/index';

export const Route = createFileRoute(
  '/_auth/_layout/parents/csv-batch-processing/',
)({
  component: ParentsOnboardingBatchesPage,
});
